(() => {
  const number = '\\d+(?:[.,]\\d+)?';
  const unit = '(?:cm|mm|inches|inch|in\\b|["″])';
  const pair = `${number}\\s*${unit}\\s*(?:/|\\()\\s*${number}\\s*${unit}\\)?`;
  const single = `(?<![\\w.,])(${number})\\s*(${unit})(?![a-z])`;
  const pattern = new RegExp(`${pair}|${single}`, 'gi');
  const format = value => String(Number(value.toFixed(2)));
  const convert = text => text.replace(pattern, (match, amount, sourceUnit) => {
    if (!amount) return match;
    const value = Number(amount.replace(',', '.'));
    const source = sourceUnit.toLowerCase();
    const cm = source === 'cm' ? value : source === 'mm' ? value / 10 : value * 2.54;
    const inches = source === 'cm' || source === 'mm' ? cm / 2.54 : value;
    return `${format(inches)} in / ${format(cm)} cm`;
  });
  if (typeof module !== 'undefined' && module.exports) module.exports = {convert};
  if (typeof document === 'undefined') return;
  const render = scope => {
    scope.querySelectorAll('[data-ke-dimensions]').forEach(root => {
      root.querySelectorAll('td').forEach(cell => {
        const original = cell.textContent;
        const converted = convert(original);
        if (converted === original) return;
        cell.textContent = converted;
        cell.classList.add('ke-dimension-value');
        cell.closest('table')?.classList.add('ke-dimensions-table');
      });
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: node => node.parentElement.closest('td,script,style,textarea,button,a')
          ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
      });
      while (walker.nextNode()) {
        const node = walker.currentNode;
        const converted = convert(node.nodeValue);
        if (converted !== node.nodeValue) node.nodeValue = converted;
      }
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => render(document), {once: true});
  } else render(document);
  document.addEventListener('shopify:section:load', event => render(event.target));
})();
